import { render } from "./etPage.vue?vue&type=template&id=ac916d04"
import script from "./etPage.vue?vue&type=script&lang=js"
export * from "./etPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__